<template>
    <div class="orderconfirm">
        <div class="order_info">
            <div class="order_status">
                <div class="status flex">
                    <div class="status_l">订单状态：<span :style="{color: status === 30 ? '#67C23A' : status === 100 ? '#C0C4CC' : status === 9 ? '#F56C6C' : ''}">{{status === 30 ? '订购成功' : status === 100 ? '订单已取消' : status === 9 ? '待支付' : ''}}</span></div>
                    <div class="status_r flex">
                        <div v-if="status === 9" class="gray" @click="cancelOrder">取消订单</div>
                        <div v-if="status === 100" class="red" @click="reOrder">重新订购</div>
                        <div v-if="status === 9" class="red" @click="toPay">立即付款</div>
                        <div v-if="status === 30" class="red" @click="reOrder">继续订购</div>
                    </div>
                </div>
                <div v-if="status === 9" class="pay_tips">请您在 {{deadtime}} 前完成支付，否则订单超时取消！</div>
            </div>
            <div class="name_order flex">
                <div>店铺名称：{{hostname}}</div>
                <div>订单号：{{orderno}}</div>
            </div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="servicename" label="服务名称"></el-table-column>
                <el-table-column prop="expireendtime" label="服务时长" align="center"></el-table-column>
                <el-table-column prop="memo" label="订单说明" align="center"></el-table-column>
                <el-table-column prop="price" label="服务价格(元)" align="right">
                    <template slot-scope="scope">￥{{scope.row.price}}</template>
                </el-table-column>
            </el-table>
        </div>
        <div class="price_box">
            <div class="price_tips">应付：<span>￥{{price}}</span></div>
        </div>
    </div>
</template>

<script>
import {getShopmoduleorderinfo, cancelPriceAssOrder, savePriceBuyInfo, getOrderPayUrl} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'orderDetail',
    data() {
        return {
            tableData: [],
            hostname: '',
            price: '',
            orderno: this.$route.query.orderno,
            status: 0,
            deadtime: '',
            modulecode: ''
        }
    },
    mounted() {
        this.getOrderInfo()
    },
    methods: {
        // 获取订单信息
        getOrderInfo() {
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            getShopmoduleorderinfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        let list = []
                        list.push({
                            servicename: data.data.servicename,
                            memo: data.data.memo,
                            expireendtime: '一年',
                            price: data.data.finalpaymoney
                        })
                        this.tableData = list
                        this.hostname = data.data.hostname
                        this.price = data.data.finalpaymoney
                        this.status = data.data.status
                        this.orderno = data.data.orderno
                        this.deadtime = data.data.latepaytime
                        this.modulecode = data.data.modulecode
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 取消订单
        cancelOrder() {
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            cancelPriceAssOrder({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('订单取消成功!')
                    this.getOrderInfo()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 重新订购
        reOrder(obj) {
            this.$router.push({name: 'orderConfirm', query: {modulecode: this.modulecode}})
            // this.$router.push({name: 'OrderService'})
            // return
            // type = type === '标准版' ? '1' : type === '专业版' ? '2' : type === '旗舰版' ? '3' : ''
            // let data = {
            //     moduletype: '1',
            //     shopvertype: type
            // }
            // this.setLoading(true)
            // savePriceBuyInfo({
            //     data: data,
            //     success: data => {
            //         this.setLoading(false)
            //         this.orderno = data.data.orderno
            //         this.$router.push({name: 'orderConfirm', query: {'orderno': data.data.orderno}})
            //     },
            //     error: data => {
            //         this.setLoading(false)
            //         this.$message.error(data.msg)
            //     }
            // })
        },

        // 立即付款
        toPay() {
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            getOrderPayUrl({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                       let url = data.data
                       console.log(url)
                       window.location = url
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.flex {
    display: flex;
}
.orderconfirm {
    background: #fff;
    height: 90vh;
    .order_info {
        padding: 0 30px;
        .order_status {
            height: 100px;
            border-bottom: 1px solid #DCDFE6;
            display: flex;
            justify-content: center;
            flex-direction: column;
            .status {
                justify-content: space-between;
                align-items: center;
                .status_l {
                    font-size: 16px;
                    color: #303133;
                    .span1 {
                        color: #67C23A;
                    }
                }
                .status_r {
                    div {
                        width: 104px;
                        height: 36px;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 36px;
                        font-size: 14px;
                        color: #606266;
                        cursor: pointer;
                    }
                    .gray {
                        border:1px solid rgba(192,196,204);
                    }
                    .red {
                        color: #fff;
                        background: #F56C6C;
                        margin-left: 20px;
                    }
                }
            }
            .pay_tips {
                font-size: 14px;
                color: #F56C6C;
            }
        }
        .name_order {
            height: 40px;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 20px;
            font-size: 14px;
            div:first-child {
                color: #303133;
            }
            div:last-child {
                color: #909399;
            }
        }
    }
    .price_box {
        height: 75px;
        padding: 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .price_tips {
            font-size: 14px;
            color: #303133;
            span {
                font-size: 20px;
                color: #F56C6C;
            }
        }
    }
}
</style>
